import { getters } from "@/constants/state";

export default {
  [getters.JOBS_GETTER]: (state) => state.jobs,
  [getters.JOBS_USER_JOBS_GETTER]: (state) => state.userJobs,
  [getters.JOBS_JOB_FILTERS_GETTER]: (state) => state.jobFilters,
  [getters.JOBS_JOB_FILTER_JOBS_GETTER]: (state) => state.jobFilterJobs,
};
